import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5020ad13&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=5020ad13&prod&scoped=true&lang=css"
import style1 from "./Header.vue?vue&type=style&index=1&id=5020ad13&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020ad13",
  null
  
)

export default component.exports